<template>
  <div class="m-auto">
    <card id="ler_step1_chckPInfoCard" tabindex="0" class="mt-15;">
      <div slot="header">
        <h3 class="card-title" align="center">본인 인증</h3>
        <h6>
          <i class="fas fa-exclamation-circle"></i>
          건축물대장상 소유자와의 일치 여부를 확인하는 절차입니다. (현재
          소유자만 방내놓기 서비스를 이용하실 수 있습니다.)
        </h6>
      </div>
      <div class="row">
        <div class="col-lg-5 fl">
          <!-- 성명 -->
          <div class="row m-row">
            <label class="col-lg-3 col-md-12 col-form-label px-0">성명</label>
            <div class="col-lg-9 col-md-12 col-sm-12 px-0">
              <ValidationProvider
                rules="required|test"
                v-slot="{ failed }"
                vid="ownerNameVal"
                ref="ownerNameVal"
              >
                <!-- _inputs.scss - .form-control - border-radius: $btn-round-radius 주석처리 하여 inputbox 네모로 만들었음 -->
                <fg-input
                  ref="ownerNameBoxRef"
                  innerRef="ownerName_inner"
                  type="text"
                  :error="failed ? '성명을 입력해주세요' : null"
                  placeholder="성명 (required)"
                  @input="$emit('ownerName', $event)"
                  v-model="ownerName"
                  :disabled="Disabled"
                >
                </fg-input>
              </ValidationProvider>
            </div>
          </div>
          <!-- 휴대전화 -->
          <div class="row m-row">
            <label class="col-lg-3 col-md-12 col-form-label px-0"
              >휴대전화</label
            >
            <div class="col-lg-9 col-md-12 col-sm-12 px-0">
              <!--sohyun 레이아웃 변경-->
              <!-- 인증버튼 있을 경우 width값 85%으로 변경 -->
              <div class="fl" style="width: 100%">
                <ValidationProvider
                  rules="required|numeric"
                  v-slot="{ failed }"
                  vid="ownerTelVal"
                >
                  <fg-input
                    class="r-noradius"
                    ref="ownerTelBoxRef"
                    innerRef="ownerTel_inner"
                    type="number"
                    :error="
                      failed ? '-없이 휴대전화 번호만 입력해주세요' : null
                    "
                    placeholder="휴대전화 (required)"
                    @input="$emit('ownerTel', $event)"
                    v-model="ownerTel"
                    :disabled="Disabled"
                  >
                  </fg-input>
                </ValidationProvider>
              </div>
              <!-- <div class="fl" style="width: 15%">
                <el-button
                  class="el-btn-height jip-cont-btn l-noradius"
                  :disabled="Disabled"
                  >인증</el-button
                >
              </div> -->
            </div>
          </div>
        </div>

        <div class="col-lg-7 fl">
          <div class="row m-row">
            <!--소유주 주소 -->
            <label class="col-lg-3 col-md-12 col-form-label px-0"
              >주소(실거주지)</label
            >
            <div class="col-lg-9 col-md-12 col-sm-12 px-0">
              <div class="fl jipvio-bg-white" style="width: 85%">
                <ValidationProvider
                  rules="required"
                  v-slot="{ failed }"
                  vid="ownerAddrVal"
                >
                  <fg-input
                    class="r-noradius"
                    ref="ownerAddrBoxRef"
                    innerRef="ownerAddr_inner"
                    type="text"
                    :error="failed ? '소유주 주소를 입력해주세요' : null"
                    placeholder="주소 (required)"
                    @keyup.enter.native="MaddressPop"
                    @click="MaddressPop"
                    v-model="ownerAddr"
                    :disabled="Disabled"
                  >
                  </fg-input>
                </ValidationProvider>
              </div>
              <div class="fl" style="width: 15%">
                <el-button
                  class="el-btn-height jip-cont-btn l-noradius"
                  icon="el-icon-search"
                  @click="MaddressPop"
                  :disabled="Disabled"
                ></el-button>
              </div>
              <!-- daum -->
              <span
                id="Mguide"
                class="fl"
                style="color: rgb(153, 153, 153); display: block;"
              ></span>
            </div>
          </div>

          <div class="row m-row">
            <!-- 소유주 상세주소 -->
            <label class="col-lg-3 col-md-12 col-form-label px-0"
              >상세주소</label
            >

            <div class="col-lg-9 col-md-12 col-sm-12 px-0">
              <ValidationProvider
                rules="required"
                v-slot="{ failed }"
                vid="ownerAddrDetailVal"
              >
                <fg-input
                  ref="ownerAddrDetailBoxRef"
                  innerRef="ownerAddrDetail_inner"
                  type="text"
                  :error="failed ? '상세주소를 입력해주세요' : null"
                  placeholder="상세주소 (required)"
                  @input="$emit('ownerAddrDetail', $event)"
                  v-model="ownerAddrDetail"
                  :disabled="Disabled"
                >
                </fg-input>
              </ValidationProvider>
              <h6 class="mb-0">
                <i class="fas fa-exclamation-circle"></i>
                실제 거주하는 곳을 입력해주세요.(전속중개계약서, 계약서 작성 시
                필요)
              </h6>
              <h6>
                <i class="fas fa-exclamation-circle"></i>
                도로명, 건물명, 지번에 대해 통합검색이 가능합니다.
              </h6>
            </div>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import { extend } from "vee-validate";
import { createNamespacedHelpers, mapGetters } from "vuex";

//test
extend("test", {
  validate: value => {
    if (value.length > 1) {
      return true;
    }
  },
  message: "서명을 입력해주세요"
});

const { mapGetters: sessionMapGetters } = createNamespacedHelpers(
  "loginSession"
);

import {
  Card,
  Form,
  FormItem,
  Button,
  CheckboxGroup,
  Checkbox,
  Input,
  Select,
  Option,
  Message
} from "element-ui";

export default {
  props: {
    Disabled: {
      type: Boolean
    }
  },
  components: {
    Card,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Button.name]: Button,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [Input.name]: Input,
    [Select.name]: Select,
    [Option.name]: Option
  },

  data() {
    return {
      ownerName: "",
      ownerTel: "",
      ownerAddr: "",
      ownerAddrDetail: ""
    };
  },
  created() {
    this.bringData();
  },

  mounted() {},
  computed: {
    ...sessionMapGetters({
      sessionPropertyInquiry: "getPropertyInquiry"
    })
  },

  methods: {
    bringData() {
      this.ownerName = this.sessionPropertyInquiry.certification.ownerName;
      this.ownerAddr = this.sessionPropertyInquiry.certification.ownerAddr;
      this.ownerAddrDetail = this.sessionPropertyInquiry.certification.ownerAddrDetail; //소유주 상세주소
      this.ownerTel = this.sessionPropertyInquiry.certification.ownerTel; // 소유주 휴대폰
    },
    MaddressPop() {
      const self = this;
      new daum.Postcode({
        oncomplete: function(data) {
          // 팝업에서 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.

          // 도로명 주소의 노출 규칙에 따라 주소를 표시한다.
          // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
          var extraRoadAddr = ""; // 참고 항목 변수

          // 법정동명이 있을 경우 추가한다. (법정리는 제외)
          // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
          if (data.bname !== "" && /[동|로|가]$/g.test(data.bname)) {
            extraRoadAddr += data.bname;
          }
          // 건물명이 있고, 공동주택일 경우 추가한다.
          if (data.buildingName !== "" && data.apartment === "Y") {
            extraRoadAddr +=
              extraRoadAddr !== ""
                ? ", " + data.buildingName
                : data.buildingName;
          }
          // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
          if (extraRoadAddr !== "") {
            extraRoadAddr = " (" + extraRoadAddr + ")";
          }

          var guideTextBox = document.getElementById("Mguide");
          // 사용자가 '선택 안함'을 클릭한 경우, 예상 주소라는 표시를 해준다.
          if (data.autoRoadAddress) {
            var expRoadAddr = data.autoRoadAddress + extraRoadAddr;
            guideTextBox.innerHTML = "(예상 도로명 주소 : " + expRoadAddr + ")";
            guideTextBox.style.display = "block";
          } else if (data.autoJibunAddress) {
            var expJibunAddr = data.autoJibunAddress;
            guideTextBox.innerHTML = "(예상 지번 주소 : " + expJibunAddr + ")";
            guideTextBox.style.display = "block";
          } else {
            guideTextBox.innerHTML = "";
            guideTextBox.style.display = "none";
          }

          self.ownerAddrInfo = data;
          self.ownerAddr = data.roadAddress;
          self.$emit("ownerAddr", self.ownerAddr);
        }
      }).open({
        left: window.screen.width / 2 - 500 / 2,
        top: window.screen.height / 2 - 600 / 2
      });
      // const popupX = (window.screen.width - 450) / 2;
      // const popupY = (window.screen.height - 500) / 2;
      // var pop2 = window.open(
      //   "./extension/juso.html",
      //   "pop_basic2",
      //   "width=450,height=550,scrollbars=yes,resizable=yes,left=" +
      //     popupX +
      //     ",top=" +
      //     popupY
      // );
    }
  }
};
</script>

<style></style>
